
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-qr-code-generator",
      function () {
        return require("private-next-pages/free-qr-code-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-qr-code-generator"])
      });
    }
  